require('./dialpad-widget-template.html');
require('./dialpad-widget.styles.less');
require('./dialpad-widget.controller');


/*****************
 ** WEBPACK FOOTER
 ** ./app/common/directives/dialpad-widget/index.js
 ** module id = 175
 ** module chunks = 0
 **/